module.exports = __webpack_public_path__ + "static/media/icon_5.0655605f.svg";